const image_dir = process.env.PUBLIC_URL + '/images';

export const ImageAssets = {
    bg_image: image_dir + '/svg/bg_image.svg',
    logo_aiia: image_dir + '/svg/logo_aiia.svg',

    icon_admin: image_dir + '/svg/icon_admin.svg',
    icon_profile: image_dir + '/svg/icon_profile.svg',
}